import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

/** When API is hosted on another origin, set `environment.apiBaseUrl` (no trailing slash). */
export const apiBaseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  const base = environment.apiBaseUrl?.trim();
  if (!base || req.url.startsWith('http://') || req.url.startsWith('https://')) {
    return next(req);
  }
  const path = req.url.replace(/^\//, '');
  const url = `${base.replace(/\/$/, '')}/${path}`;
  return next(req.clone({ url, withCredentials: true }));
};
